export class PasswordData {
    password: string;  
    errors: any | null;
  }
